import CityPage from "../CityPage";

export default function OakBrook() {
  return <CityPage slug="oak-brook" />;
}
